var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"utc-link",on:{"click":function($event){return _vm.showModal()}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.userTimezone.code))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }